import { default as _slugogdjIyBVBIMeta } from "/vercel/path0/pages/_slug.vue?macro=true";
import { default as _testkwH008VqsMMeta } from "/vercel/path0/pages/_test.vue?macro=true";
import { default as _91_46_46_46slug_93Qv3uKeTLMXMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as indexkTbHibCokdMeta } from "/vercel/path0/pages/contribution/index.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as irlen6498h2g7Meta } from "/vercel/path0/pages/irl.vue?macro=true";
import { default as indexoOBDY93e9EMeta } from "/vercel/path0/pages/login/index.vue?macro=true";
import { default as playlistGlbUJdQEfeMeta } from "/vercel/path0/pages/playlist.vue?macro=true";
import { default as indexhsFMqp9OBFMeta } from "/vercel/path0/pages/plli/index.vue?macro=true";
import { default as themeJuAnsDtBa2Meta } from "/vercel/path0/pages/plli/theme.vue?macro=true";
import { default as settingk2C5Z4r5zOMeta } from "/vercel/path0/pages/setting.vue?macro=true";
import { default as _91_46_46_46slug_934LMm2Hdm1AMeta } from "/vercel/path0/pages/word/[...slug].vue?macro=true";
import { default as indexTR3aYS74d4Meta } from "/vercel/path0/pages/word/add/index.vue?macro=true";
import { default as _91_46_46_46slug_933iNPY55Pr7Meta } from "/vercel/path0/pages/word/edit/[...slug].vue?macro=true";
import { default as indexWOyk90H554Meta } from "/vercel/path0/pages/word/index.vue?macro=true";
import { default as _91_46_46_46slug_93luzggQjLE5Meta } from "/vercel/path0/pages/word/review/[...slug].vue?macro=true";
import { default as indexF49zifSvHlMeta } from "/vercel/path0/pages/word/review/index.vue?macro=true";
import { default as component_45stubUHgG5aOkzGMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubUHgG5aOkzG } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: _slugogdjIyBVBIMeta?.name ?? "_slug___zh-tw",
    path: _slugogdjIyBVBIMeta?.path ?? "/zh-tw/_slug",
    meta: _slugogdjIyBVBIMeta || {},
    alias: _slugogdjIyBVBIMeta?.alias || [],
    redirect: _slugogdjIyBVBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/_slug.vue").then(m => m.default || m)
  },
  {
    name: _slugogdjIyBVBIMeta?.name ?? "_slug___kr",
    path: _slugogdjIyBVBIMeta?.path ?? "/kr/_slug",
    meta: _slugogdjIyBVBIMeta || {},
    alias: _slugogdjIyBVBIMeta?.alias || [],
    redirect: _slugogdjIyBVBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/_slug.vue").then(m => m.default || m)
  },
  {
    name: _slugogdjIyBVBIMeta?.name ?? "_slug___en",
    path: _slugogdjIyBVBIMeta?.path ?? "/en/_slug",
    meta: _slugogdjIyBVBIMeta || {},
    alias: _slugogdjIyBVBIMeta?.alias || [],
    redirect: _slugogdjIyBVBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/_slug.vue").then(m => m.default || m)
  },
  {
    name: _slugogdjIyBVBIMeta?.name ?? "_slug___jp",
    path: _slugogdjIyBVBIMeta?.path ?? "/jp/_slug",
    meta: _slugogdjIyBVBIMeta || {},
    alias: _slugogdjIyBVBIMeta?.alias || [],
    redirect: _slugogdjIyBVBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/_slug.vue").then(m => m.default || m)
  },
  {
    name: _slugogdjIyBVBIMeta?.name ?? "_slug___zh-cn",
    path: _slugogdjIyBVBIMeta?.path ?? "/zh-cn/_slug",
    meta: _slugogdjIyBVBIMeta || {},
    alias: _slugogdjIyBVBIMeta?.alias || [],
    redirect: _slugogdjIyBVBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/_slug.vue").then(m => m.default || m)
  },
  {
    name: _testkwH008VqsMMeta?.name ?? "_test___zh-tw",
    path: _testkwH008VqsMMeta?.path ?? "/zh-tw/_test",
    meta: _testkwH008VqsMMeta || {},
    alias: _testkwH008VqsMMeta?.alias || [],
    redirect: _testkwH008VqsMMeta?.redirect,
    component: () => import("/vercel/path0/pages/_test.vue").then(m => m.default || m)
  },
  {
    name: _testkwH008VqsMMeta?.name ?? "_test___kr",
    path: _testkwH008VqsMMeta?.path ?? "/kr/_test",
    meta: _testkwH008VqsMMeta || {},
    alias: _testkwH008VqsMMeta?.alias || [],
    redirect: _testkwH008VqsMMeta?.redirect,
    component: () => import("/vercel/path0/pages/_test.vue").then(m => m.default || m)
  },
  {
    name: _testkwH008VqsMMeta?.name ?? "_test___en",
    path: _testkwH008VqsMMeta?.path ?? "/en/_test",
    meta: _testkwH008VqsMMeta || {},
    alias: _testkwH008VqsMMeta?.alias || [],
    redirect: _testkwH008VqsMMeta?.redirect,
    component: () => import("/vercel/path0/pages/_test.vue").then(m => m.default || m)
  },
  {
    name: _testkwH008VqsMMeta?.name ?? "_test___jp",
    path: _testkwH008VqsMMeta?.path ?? "/jp/_test",
    meta: _testkwH008VqsMMeta || {},
    alias: _testkwH008VqsMMeta?.alias || [],
    redirect: _testkwH008VqsMMeta?.redirect,
    component: () => import("/vercel/path0/pages/_test.vue").then(m => m.default || m)
  },
  {
    name: _testkwH008VqsMMeta?.name ?? "_test___zh-cn",
    path: _testkwH008VqsMMeta?.path ?? "/zh-cn/_test",
    meta: _testkwH008VqsMMeta || {},
    alias: _testkwH008VqsMMeta?.alias || [],
    redirect: _testkwH008VqsMMeta?.redirect,
    component: () => import("/vercel/path0/pages/_test.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug___zh-tw",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/zh-tw/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug___kr",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/kr/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug___jp",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/jp/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug___zh-cn",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/zh-cn/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexkTbHibCokdMeta?.name ?? "contribution___zh-tw",
    path: indexkTbHibCokdMeta?.path ?? "/zh-tw/contribution",
    meta: indexkTbHibCokdMeta || {},
    alias: indexkTbHibCokdMeta?.alias || [],
    redirect: indexkTbHibCokdMeta?.redirect,
    component: () => import("/vercel/path0/pages/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: indexkTbHibCokdMeta?.name ?? "contribution___kr",
    path: indexkTbHibCokdMeta?.path ?? "/kr/contribution",
    meta: indexkTbHibCokdMeta || {},
    alias: indexkTbHibCokdMeta?.alias || [],
    redirect: indexkTbHibCokdMeta?.redirect,
    component: () => import("/vercel/path0/pages/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: indexkTbHibCokdMeta?.name ?? "contribution___en",
    path: indexkTbHibCokdMeta?.path ?? "/en/contribution",
    meta: indexkTbHibCokdMeta || {},
    alias: indexkTbHibCokdMeta?.alias || [],
    redirect: indexkTbHibCokdMeta?.redirect,
    component: () => import("/vercel/path0/pages/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: indexkTbHibCokdMeta?.name ?? "contribution___jp",
    path: indexkTbHibCokdMeta?.path ?? "/jp/contribution",
    meta: indexkTbHibCokdMeta || {},
    alias: indexkTbHibCokdMeta?.alias || [],
    redirect: indexkTbHibCokdMeta?.redirect,
    component: () => import("/vercel/path0/pages/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: indexkTbHibCokdMeta?.name ?? "contribution___zh-cn",
    path: indexkTbHibCokdMeta?.path ?? "/zh-cn/contribution",
    meta: indexkTbHibCokdMeta || {},
    alias: indexkTbHibCokdMeta?.alias || [],
    redirect: indexkTbHibCokdMeta?.redirect,
    component: () => import("/vercel/path0/pages/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___zh-tw",
    path: indexe9Brt5DfdhMeta?.path ?? "/zh-tw",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___kr",
    path: indexe9Brt5DfdhMeta?.path ?? "/kr",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___en",
    path: indexe9Brt5DfdhMeta?.path ?? "/en",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___jp",
    path: indexe9Brt5DfdhMeta?.path ?? "/jp",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___zh-cn",
    path: indexe9Brt5DfdhMeta?.path ?? "/zh-cn",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: irlen6498h2g7Meta?.name ?? "irl___zh-tw",
    path: irlen6498h2g7Meta?.path ?? "/zh-tw/irl",
    meta: irlen6498h2g7Meta || {},
    alias: irlen6498h2g7Meta?.alias || [],
    redirect: irlen6498h2g7Meta?.redirect,
    component: () => import("/vercel/path0/pages/irl.vue").then(m => m.default || m)
  },
  {
    name: irlen6498h2g7Meta?.name ?? "irl___kr",
    path: irlen6498h2g7Meta?.path ?? "/kr/irl",
    meta: irlen6498h2g7Meta || {},
    alias: irlen6498h2g7Meta?.alias || [],
    redirect: irlen6498h2g7Meta?.redirect,
    component: () => import("/vercel/path0/pages/irl.vue").then(m => m.default || m)
  },
  {
    name: irlen6498h2g7Meta?.name ?? "irl___en",
    path: irlen6498h2g7Meta?.path ?? "/en/irl",
    meta: irlen6498h2g7Meta || {},
    alias: irlen6498h2g7Meta?.alias || [],
    redirect: irlen6498h2g7Meta?.redirect,
    component: () => import("/vercel/path0/pages/irl.vue").then(m => m.default || m)
  },
  {
    name: irlen6498h2g7Meta?.name ?? "irl___jp",
    path: irlen6498h2g7Meta?.path ?? "/jp/irl",
    meta: irlen6498h2g7Meta || {},
    alias: irlen6498h2g7Meta?.alias || [],
    redirect: irlen6498h2g7Meta?.redirect,
    component: () => import("/vercel/path0/pages/irl.vue").then(m => m.default || m)
  },
  {
    name: irlen6498h2g7Meta?.name ?? "irl___zh-cn",
    path: irlen6498h2g7Meta?.path ?? "/zh-cn/irl",
    meta: irlen6498h2g7Meta || {},
    alias: irlen6498h2g7Meta?.alias || [],
    redirect: irlen6498h2g7Meta?.redirect,
    component: () => import("/vercel/path0/pages/irl.vue").then(m => m.default || m)
  },
  {
    name: indexoOBDY93e9EMeta?.name ?? "login___zh-tw",
    path: indexoOBDY93e9EMeta?.path ?? "/zh-tw/login",
    meta: indexoOBDY93e9EMeta || {},
    alias: indexoOBDY93e9EMeta?.alias || [],
    redirect: indexoOBDY93e9EMeta?.redirect,
    component: () => import("/vercel/path0/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexoOBDY93e9EMeta?.name ?? "login___kr",
    path: indexoOBDY93e9EMeta?.path ?? "/kr/login",
    meta: indexoOBDY93e9EMeta || {},
    alias: indexoOBDY93e9EMeta?.alias || [],
    redirect: indexoOBDY93e9EMeta?.redirect,
    component: () => import("/vercel/path0/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexoOBDY93e9EMeta?.name ?? "login___en",
    path: indexoOBDY93e9EMeta?.path ?? "/en/login",
    meta: indexoOBDY93e9EMeta || {},
    alias: indexoOBDY93e9EMeta?.alias || [],
    redirect: indexoOBDY93e9EMeta?.redirect,
    component: () => import("/vercel/path0/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexoOBDY93e9EMeta?.name ?? "login___jp",
    path: indexoOBDY93e9EMeta?.path ?? "/jp/login",
    meta: indexoOBDY93e9EMeta || {},
    alias: indexoOBDY93e9EMeta?.alias || [],
    redirect: indexoOBDY93e9EMeta?.redirect,
    component: () => import("/vercel/path0/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexoOBDY93e9EMeta?.name ?? "login___zh-cn",
    path: indexoOBDY93e9EMeta?.path ?? "/zh-cn/login",
    meta: indexoOBDY93e9EMeta || {},
    alias: indexoOBDY93e9EMeta?.alias || [],
    redirect: indexoOBDY93e9EMeta?.redirect,
    component: () => import("/vercel/path0/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: playlistGlbUJdQEfeMeta?.name ?? "playlist___zh-tw",
    path: playlistGlbUJdQEfeMeta?.path ?? "/zh-tw/playlist",
    meta: playlistGlbUJdQEfeMeta || {},
    alias: playlistGlbUJdQEfeMeta?.alias || [],
    redirect: playlistGlbUJdQEfeMeta?.redirect,
    component: () => import("/vercel/path0/pages/playlist.vue").then(m => m.default || m)
  },
  {
    name: playlistGlbUJdQEfeMeta?.name ?? "playlist___kr",
    path: playlistGlbUJdQEfeMeta?.path ?? "/kr/playlist",
    meta: playlistGlbUJdQEfeMeta || {},
    alias: playlistGlbUJdQEfeMeta?.alias || [],
    redirect: playlistGlbUJdQEfeMeta?.redirect,
    component: () => import("/vercel/path0/pages/playlist.vue").then(m => m.default || m)
  },
  {
    name: playlistGlbUJdQEfeMeta?.name ?? "playlist___en",
    path: playlistGlbUJdQEfeMeta?.path ?? "/en/playlist",
    meta: playlistGlbUJdQEfeMeta || {},
    alias: playlistGlbUJdQEfeMeta?.alias || [],
    redirect: playlistGlbUJdQEfeMeta?.redirect,
    component: () => import("/vercel/path0/pages/playlist.vue").then(m => m.default || m)
  },
  {
    name: playlistGlbUJdQEfeMeta?.name ?? "playlist___jp",
    path: playlistGlbUJdQEfeMeta?.path ?? "/jp/playlist",
    meta: playlistGlbUJdQEfeMeta || {},
    alias: playlistGlbUJdQEfeMeta?.alias || [],
    redirect: playlistGlbUJdQEfeMeta?.redirect,
    component: () => import("/vercel/path0/pages/playlist.vue").then(m => m.default || m)
  },
  {
    name: playlistGlbUJdQEfeMeta?.name ?? "playlist___zh-cn",
    path: playlistGlbUJdQEfeMeta?.path ?? "/zh-cn/playlist",
    meta: playlistGlbUJdQEfeMeta || {},
    alias: playlistGlbUJdQEfeMeta?.alias || [],
    redirect: playlistGlbUJdQEfeMeta?.redirect,
    component: () => import("/vercel/path0/pages/playlist.vue").then(m => m.default || m)
  },
  {
    name: indexhsFMqp9OBFMeta?.name ?? "plli___zh-tw",
    path: indexhsFMqp9OBFMeta?.path ?? "/zh-tw/plli",
    meta: indexhsFMqp9OBFMeta || {},
    alias: indexhsFMqp9OBFMeta?.alias || [],
    redirect: indexhsFMqp9OBFMeta?.redirect,
    component: () => import("/vercel/path0/pages/plli/index.vue").then(m => m.default || m)
  },
  {
    name: indexhsFMqp9OBFMeta?.name ?? "plli___kr",
    path: indexhsFMqp9OBFMeta?.path ?? "/kr/plli",
    meta: indexhsFMqp9OBFMeta || {},
    alias: indexhsFMqp9OBFMeta?.alias || [],
    redirect: indexhsFMqp9OBFMeta?.redirect,
    component: () => import("/vercel/path0/pages/plli/index.vue").then(m => m.default || m)
  },
  {
    name: indexhsFMqp9OBFMeta?.name ?? "plli___en",
    path: indexhsFMqp9OBFMeta?.path ?? "/en/plli",
    meta: indexhsFMqp9OBFMeta || {},
    alias: indexhsFMqp9OBFMeta?.alias || [],
    redirect: indexhsFMqp9OBFMeta?.redirect,
    component: () => import("/vercel/path0/pages/plli/index.vue").then(m => m.default || m)
  },
  {
    name: indexhsFMqp9OBFMeta?.name ?? "plli___jp",
    path: indexhsFMqp9OBFMeta?.path ?? "/jp/plli",
    meta: indexhsFMqp9OBFMeta || {},
    alias: indexhsFMqp9OBFMeta?.alias || [],
    redirect: indexhsFMqp9OBFMeta?.redirect,
    component: () => import("/vercel/path0/pages/plli/index.vue").then(m => m.default || m)
  },
  {
    name: indexhsFMqp9OBFMeta?.name ?? "plli___zh-cn",
    path: indexhsFMqp9OBFMeta?.path ?? "/zh-cn/plli",
    meta: indexhsFMqp9OBFMeta || {},
    alias: indexhsFMqp9OBFMeta?.alias || [],
    redirect: indexhsFMqp9OBFMeta?.redirect,
    component: () => import("/vercel/path0/pages/plli/index.vue").then(m => m.default || m)
  },
  {
    name: themeJuAnsDtBa2Meta?.name ?? "plli-theme___zh-tw",
    path: themeJuAnsDtBa2Meta?.path ?? "/zh-tw/plli/theme",
    meta: themeJuAnsDtBa2Meta || {},
    alias: themeJuAnsDtBa2Meta?.alias || [],
    redirect: themeJuAnsDtBa2Meta?.redirect,
    component: () => import("/vercel/path0/pages/plli/theme.vue").then(m => m.default || m)
  },
  {
    name: themeJuAnsDtBa2Meta?.name ?? "plli-theme___kr",
    path: themeJuAnsDtBa2Meta?.path ?? "/kr/plli/theme",
    meta: themeJuAnsDtBa2Meta || {},
    alias: themeJuAnsDtBa2Meta?.alias || [],
    redirect: themeJuAnsDtBa2Meta?.redirect,
    component: () => import("/vercel/path0/pages/plli/theme.vue").then(m => m.default || m)
  },
  {
    name: themeJuAnsDtBa2Meta?.name ?? "plli-theme___en",
    path: themeJuAnsDtBa2Meta?.path ?? "/en/plli/theme",
    meta: themeJuAnsDtBa2Meta || {},
    alias: themeJuAnsDtBa2Meta?.alias || [],
    redirect: themeJuAnsDtBa2Meta?.redirect,
    component: () => import("/vercel/path0/pages/plli/theme.vue").then(m => m.default || m)
  },
  {
    name: themeJuAnsDtBa2Meta?.name ?? "plli-theme___jp",
    path: themeJuAnsDtBa2Meta?.path ?? "/jp/plli/theme",
    meta: themeJuAnsDtBa2Meta || {},
    alias: themeJuAnsDtBa2Meta?.alias || [],
    redirect: themeJuAnsDtBa2Meta?.redirect,
    component: () => import("/vercel/path0/pages/plli/theme.vue").then(m => m.default || m)
  },
  {
    name: themeJuAnsDtBa2Meta?.name ?? "plli-theme___zh-cn",
    path: themeJuAnsDtBa2Meta?.path ?? "/zh-cn/plli/theme",
    meta: themeJuAnsDtBa2Meta || {},
    alias: themeJuAnsDtBa2Meta?.alias || [],
    redirect: themeJuAnsDtBa2Meta?.redirect,
    component: () => import("/vercel/path0/pages/plli/theme.vue").then(m => m.default || m)
  },
  {
    name: settingk2C5Z4r5zOMeta?.name ?? "setting___zh-tw",
    path: settingk2C5Z4r5zOMeta?.path ?? "/zh-tw/setting",
    meta: settingk2C5Z4r5zOMeta || {},
    alias: settingk2C5Z4r5zOMeta?.alias || [],
    redirect: settingk2C5Z4r5zOMeta?.redirect,
    component: () => import("/vercel/path0/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: settingk2C5Z4r5zOMeta?.name ?? "setting___kr",
    path: settingk2C5Z4r5zOMeta?.path ?? "/kr/setting",
    meta: settingk2C5Z4r5zOMeta || {},
    alias: settingk2C5Z4r5zOMeta?.alias || [],
    redirect: settingk2C5Z4r5zOMeta?.redirect,
    component: () => import("/vercel/path0/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: settingk2C5Z4r5zOMeta?.name ?? "setting___en",
    path: settingk2C5Z4r5zOMeta?.path ?? "/en/setting",
    meta: settingk2C5Z4r5zOMeta || {},
    alias: settingk2C5Z4r5zOMeta?.alias || [],
    redirect: settingk2C5Z4r5zOMeta?.redirect,
    component: () => import("/vercel/path0/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: settingk2C5Z4r5zOMeta?.name ?? "setting___jp",
    path: settingk2C5Z4r5zOMeta?.path ?? "/jp/setting",
    meta: settingk2C5Z4r5zOMeta || {},
    alias: settingk2C5Z4r5zOMeta?.alias || [],
    redirect: settingk2C5Z4r5zOMeta?.redirect,
    component: () => import("/vercel/path0/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: settingk2C5Z4r5zOMeta?.name ?? "setting___zh-cn",
    path: settingk2C5Z4r5zOMeta?.path ?? "/zh-cn/setting",
    meta: settingk2C5Z4r5zOMeta || {},
    alias: settingk2C5Z4r5zOMeta?.alias || [],
    redirect: settingk2C5Z4r5zOMeta?.redirect,
    component: () => import("/vercel/path0/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934LMm2Hdm1AMeta?.name ?? "word-slug___zh-tw",
    path: _91_46_46_46slug_934LMm2Hdm1AMeta?.path ?? "/zh-tw/word/:slug(.*)*",
    meta: _91_46_46_46slug_934LMm2Hdm1AMeta || {},
    alias: _91_46_46_46slug_934LMm2Hdm1AMeta?.alias || [],
    redirect: _91_46_46_46slug_934LMm2Hdm1AMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934LMm2Hdm1AMeta?.name ?? "word-slug___kr",
    path: _91_46_46_46slug_934LMm2Hdm1AMeta?.path ?? "/kr/word/:slug(.*)*",
    meta: _91_46_46_46slug_934LMm2Hdm1AMeta || {},
    alias: _91_46_46_46slug_934LMm2Hdm1AMeta?.alias || [],
    redirect: _91_46_46_46slug_934LMm2Hdm1AMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934LMm2Hdm1AMeta?.name ?? "word-slug___en",
    path: _91_46_46_46slug_934LMm2Hdm1AMeta?.path ?? "/en/word/:slug(.*)*",
    meta: _91_46_46_46slug_934LMm2Hdm1AMeta || {},
    alias: _91_46_46_46slug_934LMm2Hdm1AMeta?.alias || [],
    redirect: _91_46_46_46slug_934LMm2Hdm1AMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934LMm2Hdm1AMeta?.name ?? "word-slug___jp",
    path: _91_46_46_46slug_934LMm2Hdm1AMeta?.path ?? "/jp/word/:slug(.*)*",
    meta: _91_46_46_46slug_934LMm2Hdm1AMeta || {},
    alias: _91_46_46_46slug_934LMm2Hdm1AMeta?.alias || [],
    redirect: _91_46_46_46slug_934LMm2Hdm1AMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934LMm2Hdm1AMeta?.name ?? "word-slug___zh-cn",
    path: _91_46_46_46slug_934LMm2Hdm1AMeta?.path ?? "/zh-cn/word/:slug(.*)*",
    meta: _91_46_46_46slug_934LMm2Hdm1AMeta || {},
    alias: _91_46_46_46slug_934LMm2Hdm1AMeta?.alias || [],
    redirect: _91_46_46_46slug_934LMm2Hdm1AMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexTR3aYS74d4Meta?.name ?? "word-add___zh-tw",
    path: indexTR3aYS74d4Meta?.path ?? "/zh-tw/word/add",
    meta: indexTR3aYS74d4Meta || {},
    alias: indexTR3aYS74d4Meta?.alias || [],
    redirect: indexTR3aYS74d4Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/add/index.vue").then(m => m.default || m)
  },
  {
    name: indexTR3aYS74d4Meta?.name ?? "word-add___kr",
    path: indexTR3aYS74d4Meta?.path ?? "/kr/word/add",
    meta: indexTR3aYS74d4Meta || {},
    alias: indexTR3aYS74d4Meta?.alias || [],
    redirect: indexTR3aYS74d4Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/add/index.vue").then(m => m.default || m)
  },
  {
    name: indexTR3aYS74d4Meta?.name ?? "word-add___en",
    path: indexTR3aYS74d4Meta?.path ?? "/en/word/add",
    meta: indexTR3aYS74d4Meta || {},
    alias: indexTR3aYS74d4Meta?.alias || [],
    redirect: indexTR3aYS74d4Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/add/index.vue").then(m => m.default || m)
  },
  {
    name: indexTR3aYS74d4Meta?.name ?? "word-add___jp",
    path: indexTR3aYS74d4Meta?.path ?? "/jp/word/add",
    meta: indexTR3aYS74d4Meta || {},
    alias: indexTR3aYS74d4Meta?.alias || [],
    redirect: indexTR3aYS74d4Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/add/index.vue").then(m => m.default || m)
  },
  {
    name: indexTR3aYS74d4Meta?.name ?? "word-add___zh-cn",
    path: indexTR3aYS74d4Meta?.path ?? "/zh-cn/word/add",
    meta: indexTR3aYS74d4Meta || {},
    alias: indexTR3aYS74d4Meta?.alias || [],
    redirect: indexTR3aYS74d4Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/add/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933iNPY55Pr7Meta?.name ?? "word-edit-slug___zh-tw",
    path: _91_46_46_46slug_933iNPY55Pr7Meta?.path ?? "/zh-tw/word/edit/:slug(.*)*",
    meta: _91_46_46_46slug_933iNPY55Pr7Meta || {},
    alias: _91_46_46_46slug_933iNPY55Pr7Meta?.alias || [],
    redirect: _91_46_46_46slug_933iNPY55Pr7Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/edit/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933iNPY55Pr7Meta?.name ?? "word-edit-slug___kr",
    path: _91_46_46_46slug_933iNPY55Pr7Meta?.path ?? "/kr/word/edit/:slug(.*)*",
    meta: _91_46_46_46slug_933iNPY55Pr7Meta || {},
    alias: _91_46_46_46slug_933iNPY55Pr7Meta?.alias || [],
    redirect: _91_46_46_46slug_933iNPY55Pr7Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/edit/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933iNPY55Pr7Meta?.name ?? "word-edit-slug___en",
    path: _91_46_46_46slug_933iNPY55Pr7Meta?.path ?? "/en/word/edit/:slug(.*)*",
    meta: _91_46_46_46slug_933iNPY55Pr7Meta || {},
    alias: _91_46_46_46slug_933iNPY55Pr7Meta?.alias || [],
    redirect: _91_46_46_46slug_933iNPY55Pr7Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/edit/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933iNPY55Pr7Meta?.name ?? "word-edit-slug___jp",
    path: _91_46_46_46slug_933iNPY55Pr7Meta?.path ?? "/jp/word/edit/:slug(.*)*",
    meta: _91_46_46_46slug_933iNPY55Pr7Meta || {},
    alias: _91_46_46_46slug_933iNPY55Pr7Meta?.alias || [],
    redirect: _91_46_46_46slug_933iNPY55Pr7Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/edit/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933iNPY55Pr7Meta?.name ?? "word-edit-slug___zh-cn",
    path: _91_46_46_46slug_933iNPY55Pr7Meta?.path ?? "/zh-cn/word/edit/:slug(.*)*",
    meta: _91_46_46_46slug_933iNPY55Pr7Meta || {},
    alias: _91_46_46_46slug_933iNPY55Pr7Meta?.alias || [],
    redirect: _91_46_46_46slug_933iNPY55Pr7Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/edit/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexWOyk90H554Meta?.name ?? "word___zh-tw",
    path: indexWOyk90H554Meta?.path ?? "/zh-tw/word",
    meta: indexWOyk90H554Meta || {},
    alias: indexWOyk90H554Meta?.alias || [],
    redirect: indexWOyk90H554Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/index.vue").then(m => m.default || m)
  },
  {
    name: indexWOyk90H554Meta?.name ?? "word___kr",
    path: indexWOyk90H554Meta?.path ?? "/kr/word",
    meta: indexWOyk90H554Meta || {},
    alias: indexWOyk90H554Meta?.alias || [],
    redirect: indexWOyk90H554Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/index.vue").then(m => m.default || m)
  },
  {
    name: indexWOyk90H554Meta?.name ?? "word___en",
    path: indexWOyk90H554Meta?.path ?? "/en/word",
    meta: indexWOyk90H554Meta || {},
    alias: indexWOyk90H554Meta?.alias || [],
    redirect: indexWOyk90H554Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/index.vue").then(m => m.default || m)
  },
  {
    name: indexWOyk90H554Meta?.name ?? "word___jp",
    path: indexWOyk90H554Meta?.path ?? "/jp/word",
    meta: indexWOyk90H554Meta || {},
    alias: indexWOyk90H554Meta?.alias || [],
    redirect: indexWOyk90H554Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/index.vue").then(m => m.default || m)
  },
  {
    name: indexWOyk90H554Meta?.name ?? "word___zh-cn",
    path: indexWOyk90H554Meta?.path ?? "/zh-cn/word",
    meta: indexWOyk90H554Meta || {},
    alias: indexWOyk90H554Meta?.alias || [],
    redirect: indexWOyk90H554Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93luzggQjLE5Meta?.name ?? "word-review-slug___zh-tw",
    path: _91_46_46_46slug_93luzggQjLE5Meta?.path ?? "/zh-tw/word/review/:slug(.*)*",
    meta: _91_46_46_46slug_93luzggQjLE5Meta || {},
    alias: _91_46_46_46slug_93luzggQjLE5Meta?.alias || [],
    redirect: _91_46_46_46slug_93luzggQjLE5Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93luzggQjLE5Meta?.name ?? "word-review-slug___kr",
    path: _91_46_46_46slug_93luzggQjLE5Meta?.path ?? "/kr/word/review/:slug(.*)*",
    meta: _91_46_46_46slug_93luzggQjLE5Meta || {},
    alias: _91_46_46_46slug_93luzggQjLE5Meta?.alias || [],
    redirect: _91_46_46_46slug_93luzggQjLE5Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93luzggQjLE5Meta?.name ?? "word-review-slug___en",
    path: _91_46_46_46slug_93luzggQjLE5Meta?.path ?? "/en/word/review/:slug(.*)*",
    meta: _91_46_46_46slug_93luzggQjLE5Meta || {},
    alias: _91_46_46_46slug_93luzggQjLE5Meta?.alias || [],
    redirect: _91_46_46_46slug_93luzggQjLE5Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93luzggQjLE5Meta?.name ?? "word-review-slug___jp",
    path: _91_46_46_46slug_93luzggQjLE5Meta?.path ?? "/jp/word/review/:slug(.*)*",
    meta: _91_46_46_46slug_93luzggQjLE5Meta || {},
    alias: _91_46_46_46slug_93luzggQjLE5Meta?.alias || [],
    redirect: _91_46_46_46slug_93luzggQjLE5Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93luzggQjLE5Meta?.name ?? "word-review-slug___zh-cn",
    path: _91_46_46_46slug_93luzggQjLE5Meta?.path ?? "/zh-cn/word/review/:slug(.*)*",
    meta: _91_46_46_46slug_93luzggQjLE5Meta || {},
    alias: _91_46_46_46slug_93luzggQjLE5Meta?.alias || [],
    redirect: _91_46_46_46slug_93luzggQjLE5Meta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexF49zifSvHlMeta?.name ?? "word-review___zh-tw",
    path: indexF49zifSvHlMeta?.path ?? "/zh-tw/word/review",
    meta: indexF49zifSvHlMeta || {},
    alias: indexF49zifSvHlMeta?.alias || [],
    redirect: indexF49zifSvHlMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/index.vue").then(m => m.default || m)
  },
  {
    name: indexF49zifSvHlMeta?.name ?? "word-review___kr",
    path: indexF49zifSvHlMeta?.path ?? "/kr/word/review",
    meta: indexF49zifSvHlMeta || {},
    alias: indexF49zifSvHlMeta?.alias || [],
    redirect: indexF49zifSvHlMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/index.vue").then(m => m.default || m)
  },
  {
    name: indexF49zifSvHlMeta?.name ?? "word-review___en",
    path: indexF49zifSvHlMeta?.path ?? "/en/word/review",
    meta: indexF49zifSvHlMeta || {},
    alias: indexF49zifSvHlMeta?.alias || [],
    redirect: indexF49zifSvHlMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/index.vue").then(m => m.default || m)
  },
  {
    name: indexF49zifSvHlMeta?.name ?? "word-review___jp",
    path: indexF49zifSvHlMeta?.path ?? "/jp/word/review",
    meta: indexF49zifSvHlMeta || {},
    alias: indexF49zifSvHlMeta?.alias || [],
    redirect: indexF49zifSvHlMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/index.vue").then(m => m.default || m)
  },
  {
    name: indexF49zifSvHlMeta?.name ?? "word-review___zh-cn",
    path: indexF49zifSvHlMeta?.path ?? "/zh-cn/word/review",
    meta: indexF49zifSvHlMeta || {},
    alias: indexF49zifSvHlMeta?.alias || [],
    redirect: indexF49zifSvHlMeta?.redirect,
    component: () => import("/vercel/path0/pages/word/review/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubUHgG5aOkzGMeta?.name ?? undefined,
    path: component_45stubUHgG5aOkzGMeta?.path ?? "/sitemap.xml",
    meta: component_45stubUHgG5aOkzGMeta || {},
    alias: component_45stubUHgG5aOkzGMeta?.alias || [],
    redirect: component_45stubUHgG5aOkzGMeta?.redirect,
    component: component_45stubUHgG5aOkzG
  }
]